import { render, staticRenderFns } from "./ClassificationItem.vue?vue&type=template&id=031a7b91&scoped=true&"
import script from "./ClassificationItem.vue?vue&type=script&lang=js&"
export * from "./ClassificationItem.vue?vue&type=script&lang=js&"
import style0 from "./ClassificationItem.vue?vue&type=style&index=0&id=031a7b91&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031a7b91",
  null
  
)

export default component.exports